import { useTheme } from "../theme/ThemeProvider.js";
import { Icon } from "./Icon.js";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      className="p-2 hover:bg-surface-container rounded-md transition-all active:scale-[0.98] text-on-surface-variant"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
    >
      <Icon name={theme === "dark" ? "light_mode" : "dark_mode"} />
    </button>
  );
}
